import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
class Button extends BridgeComponent {
    static component = "button";
    connect() {
        const element = this.bridgeElement;
        const iosImage = element.bridgeAttribute("ios-image");
        const androidImage = element.bridgeAttribute("android-image");
        const data = { title: element.title, iosImage, androidImage };

        this.send("connect", data, (response) => {
            this.element.click();
        });
    }

    disconnect() {
        this.send("disconnect");
    }
}

export default Button;
